import { render, staticRenderFns } from "./Theme.vue?vue&type=template&id=96dfa502&"
import script from "./Theme.vue?vue&type=script&lang=ts&"
export * from "./Theme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports